import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Navbar, { scrollToSection } from "@/components/Navbar";
import { useSEO } from "@/lib/seo";
import Hero from "@/components/Hero";
import Stats from "@/components/Stats";
import Divisions from "@/components/Divisions";
import WhoWeAre from "@/components/WhoWeAre";
import Presence from "@/components/Presence";
import Leadership from "@/components/Leadership";
import ClientsMarquee from "@/components/ClientsMarquee";
import TrustedBy from "@/components/TrustedBy";
import Events from "@/components/Events";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

export default function Home() {
  const location = useLocation();
  useSEO({
    path: "/",
    description:
      "GENOUM GROUP (Genoum Private Limited) — solar & renewable energy, green hydrogen, turnkey EPC and advanced medical technology. Offices in Bhubaneswar, Balasore and Ghaziabad.",
  });

  useEffect(() => {
    if (location.state?.scrollTo) {
      const t = setTimeout(() => scrollToSection(location.state.scrollTo), 400);
      return () => clearTimeout(t);
    }
    // No explicit target: open at the hero. The other pages already do this;
    // Home did not, so a reload left you wherever you had scrolled to.
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [location.state]);

  return (
    <div className="bg-navy min-h-screen text-slate-50" data-testid="home-page">
      <Navbar />
      <main>
        <Hero />
        <Stats />
        <Divisions />
        <WhoWeAre />
        <Presence />
        <Leadership />
        <ClientsMarquee />
        <TrustedBy />
        <Events />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
